import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import { services } from '../../services';

export const useGetCollectionProducts = code =>
  useQuery(
    createQueryKey(QUERY_KEYS.useGetCollectionProductsKey, code),
    () => services.products(code),
    {
      enabled: !!code
    }
  );
